
export class GetBulkDanceManagersRequestDto {
  ids: string[];
}
